import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__word } from '@shared/dto/+word/word_translated/DTO__word';
import { DTO__words_vocabulary } from '@shared/dto/+word/word_translated/DTO__words_vocabulary';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { StateWords } from './state_words';

export const local_words_upsert = (payload: DTO__word[]): PayloadAction<DTO__word[]> => ({
  type: ENUM__redux_action.WORDS_UPSERT,
  payload,
});

export const init_local_words_upsert = (state: StateWords, action: PayloadAction<DTO__word[]>) => {
  for (let dto_word of action.payload) {
    let vocabulary = state.words_vocabularies.get(dto_word.language);

    if (!vocabulary) {
      vocabulary = new DTO__words_vocabulary();
      vocabulary.language = dto_word.language;
      state.words_vocabularies.set(dto_word.language, vocabulary);
    }

    vocabulary.words_map.set(dto_word.word_english, dto_word);
  }

  //need to force re-render
  state.words_vocabularies = new Map(state.words_vocabularies);

  //need to force re-render
  state.words_with_related_words_map = new Map(state.words_with_related_words_map);
};
